// Copyright 1999-2023. Plesk International GmbH. All rights reserved.

import { createContext } from 'react';
const FormContext = /*#__PURE__*/createContext(undefined);
FormContext.displayName = 'FormContext';
export default FormContext;